/*
 * @Author: Cphayim
 * @Date: 2019-10-06 01:32:07
 * @LastEditTime: 2021-09-27 11:31:36
 * @Description: 守卫入口
 */
import { loginStateGuard } from './login-state'
// import { keepAliveGuard } from './keep-alive'

import { updateTitleGuard } from './title'

/**
 * 注册前置守卫
 * @param {VueRouter} router
 */
export function registerBeforeGuard(router) {
  // 守卫队列
  const guardQueue = [loginStateGuard]
  guardQueue.forEach(guard => {
    return router.beforeEach(guard)
  })
}

/**
 * 注册后置守卫
 * @param {VueRouter} router
 */
export function registerAfterGuard(router) {
  // 守卫队列
  const guardQueue = [updateTitleGuard]
  guardQueue.forEach(guard => router.afterEach(guard))
}
